import { render, staticRenderFns } from "./ServiceProviderLawyersOfficesApplicationsCard.vue?vue&type=template&id=5b515fea&scoped=true"
import script from "./ServiceProviderLawyersOfficesApplicationsCard.vue?vue&type=script&lang=js"
export * from "./ServiceProviderLawyersOfficesApplicationsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b515fea",
  null
  
)

export default component.exports